import $ from 'jquery';
import {formatMoney} from '@shopify/theme-currency';

export default () => {
  if ($('[data-slider-cart-promo]').length === 0) {
    return;
  }
  $(document).on('cartDidUpdate', (e, cart) => {
    if (!$('[data-slider-cart-promo]').data('dynamic')) { return; }

    let cart_message = '';
    const away = 10000 - cart.total_price;
    if (away > 0) {
      if (cart.total_price === 0) {
        cart_message = 'Free shipping for orders over $100';
      } else {
        cart_message = `Only ${formatMoney(away, theme.moneyFormat)} away from free shipping`;
      }
    } else {
      cart_message = 'Congratulations! You\'ve got free shipping';
    }

    $('[data-slider-cart-promo] p').html(cart_message);
  });
}; 
